const Routes = {
  Landing: '/',
  LegacyLanding: '/landing/',
  Home: '/app/',
  Channels: '/app/channel/',
  Channel: (id: string) => `/app/channel/${id}`,
  ChannelVideo: (id: string) => `/app/channel/${id}`,
  ChannelStream: (id: string) => `/app/channel/${id}/streams/`,
  ChannelShorts: (id: string) => `/app/channel/${id}/shorts/`,
  ChannelPlaylist: (id: string) => `/app/channel/${id}/playlist/`,
  ChannelAbout: (id: string) => `/app/channel/${id}/about/`,
  Playlists: '/app/playlist/',
  Playlist: (id: string) => `/app/playlist/${id}`,
  Downloads: '/app/downloads/',
  DownloadsByChannelId: (channelId: string) => `/app/downloads/?channel=${channelId}&ignored=false`,
  IgnoredByChannelId: (channelId: string) => `/app/downloads/?channel=${channelId}&ignored=true`,
  Search: '/app/search/',
  SettingsDashboard: '/app/settings/',
  SettingsUser: '/app/settings/user/',
  SettingsApplication: '/app/settings/application/',
  SettingsScheduling: '/app/settings/scheduling/',
  SettingsActions: '/app/settings/actions/',
  Login: '/login/',
  AuthCallback: '/auth/callback/',
  Register: '/register/',
  Privacy: '/privacy/',
  Terms: '/terms/',
  Video: (id: string) => `/app/video/${id}`,
  VideoAtTimestamp: (id: string, timestamp: string) => `/app/video/${id}/?t=${timestamp}`,
  About: '/app/about/',
  Upload: '/app/upload/',
  Notes: '/app/notes/',
  TranscriptionNote: (id: string) => `/app/upload/note/${id}/`,
};

export default Routes;
